import { GalleryConfig } from 'rangeConfig/@types';

const boaxelGalleryConfig: GalleryConfig = {
  default: [
    {
      sprs: [
        { id: 'SPR-49332376' },
        { id: 'SPR-89386485' },
        { id: 'SPR-19332373' },
        { id: 'SPR-59386482' },
        { id: 'SPR-89384014' },
        { id: 'SPR-99548864' },
        { id: 'SPR-49548890' },
        { id: 'SPR-39564475' },
        { id: 'SPR-19564476' },
        { id: 'SPR-99564477' },
        { id: 'SPR-79564478' },
        { id: 'SPR-69548894' },
        { id: 'SPR-69548912' }
      ]
    }
  ]
};

export default boaxelGalleryConfig;
